<template>
  <div :class="$style.subbar">
    <ul :class="$style.breadcrumbs" class="mr-4">
<!--      <li :class="$style.breadcrumb">-->
<!--        <a href="#" class="style.breadcrumbLink">Main</a>-->
<!--      </li>-->
      <li :class="$style.breadcrumb">
        <a href="#" :class="[$style.breadcrumbLink, $style.breadcrumbLink__current]">{{this.$route.meta.title}}</a>
      </li>
    </ul>
    <div :class="$style.divider" class="mr-4 d-none d-xl-block" />
    <new-reservation-button />
    <div :class="$style.amount" v-if="false" class="mr-3 ml-auto d-none d-sm-flex">
      <p :class="$style.amountText">
        Deze maand
        <span :class="$style.amountValue">€251.12</span>
      </p>
      <div :class="$style.amountGraph">
        <i :class="$style.amountGraphItem" :style="{ height: '80%' }" />
        <i :class="$style.amountGraphItem" :style="{ height: '50%' }" />
        <i :class="$style.amountGraphItem" :style="{ height: '70%' }" />
        <i :class="$style.amountGraphItem" :style="{ height: '60%' }" />
        <i :class="$style.amountGraphItem" :style="{ height: '50%' }" />
        <i :class="$style.amountGraphItem" :style="{ height: '65%' }" />
      </div>
    </div>
    <div :class="$style.amount" v-if="false" class="d-none d-sm-flex">
      <p :class="$style.amountText">
        Vorige maand
        <span :class="$style.amountValue">€12,256.12</span>
      </p>
      <div :class="$style.amountGraph">
        <i :class="$style.amountGraphItem" :style="{ height: '60%' }" />
        <i :class="$style.amountGraphItem" :style="{ height: '65%' }" />
        <i :class="$style.amountGraphItem" :style="{ height: '75%' }" />
        <i :class="$style.amountGraphItem" :style="{ height: '55%' }" />
        <i :class="$style.amountGraphItem" :style="{ height: '100%' }" />
        <i :class="$style.amountGraphItem" :style="{ height: '85%' }" />
      </div>
    </div>
  </div>
</template>
<script>
import NewReservationButton from '../../widgets/Reservations/NewReservationButton'

export default {
  components: {
    NewReservationButton
  }
}
</script>
<style lang="scss" module>
@import "./style.module.scss";
</style>
